import {
  useLazyGetAllDocumentsByArtifactnameSitelevelQuery,
  useGetAllDocumentsByArtifactnameStudylevelMutation,
  useLazyGetDcocListByStudyidArtifactnameQuery
} from 'src/services/etmfDocLevel';

import {
  useCreateContractBudgetMutation,
  useGetContractBudgetDataQuery,
  useUpdateContractBudgetMutation
} from 'src/services/StartupPacket';
import { useAppSelector } from 'src/store';

export const useStartUpPacket = () => {
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const country = useAppSelector(state => state.site.selectedCountry);
  const siteId = useAppSelector(state => state.site.selectedSite);
  const application = process.env.REACT_APP_NAME;
  const [
    getDocsByArtifactNameStudyLevel,
    { data: getDocsByArtifactNameStudyLevelData, error: getDocsByArtifactNameStudyLevelError }
  ] = useGetAllDocumentsByArtifactnameStudylevelMutation();

  const [
    getDocListByStudyLevelArtifact,
    { data: getDocListByStudyLevelArtifactData, error: getDocListByStudyLevelArtifactError }
  ] = useLazyGetDcocListByStudyidArtifactnameQuery();

  const [
    getDocListBySiteLevelArtifact,
    { data: getDocListBySiteLevelArtifactData, error: getDocListBySiteLevelArtifactError }
  ] = useLazyGetAllDocumentsByArtifactnameSitelevelQuery();

  const {
    isLoading: getContractBudgetLoading,
    isError: getContractBudgetIsError,
    data: contractBudgetData,
    error: getContractBudgetError,
    refetch: getContractBudgetQueryData
  } = useGetContractBudgetDataQuery({
    site_id: siteId,
    study_id: studyId,
    country,
    application
  });

  const [
    createContractBudget,
    {
      isLoading: createContractBudgetLoading,
      isError: createContractBudgetIsError,
      data: createContractBudgetData,
      error: createContractBudgetError
    }
  ] = useCreateContractBudgetMutation();
  const [
    updateContractBudget,
    {
      isLoading: updateContractBudgetLoading,
      isError: updateContractBudgetIsError,
      data: updateContractBudgetData,
      error: updateContractBudgetError
    }
  ] = useUpdateContractBudgetMutation();

  return {
    getDocsByArtifactNameStudyLevel,
    getDocsByArtifactNameStudyLevelData,
    getDocsByArtifactNameStudyLevelError,
    getDocListByStudyLevelArtifact,
    getDocListByStudyLevelArtifactData,
    getDocListByStudyLevelArtifactError,
    createContractBudget,
    createContractBudgetLoading,
    createContractBudgetIsError,
    createContractBudgetData,
    createContractBudgetError,
    updateContractBudget,
    updateContractBudgetLoading,
    updateContractBudgetIsError,
    updateContractBudgetData,
    updateContractBudgetError,
    contractBudgetData,
    getContractBudgetError,
    getContractBudgetQueryData,
    getDocListBySiteLevelArtifact,
    getDocListBySiteLevelArtifactData,
    getDocListBySiteLevelArtifactError,
    getContractBudgetLoading,
    getContractBudgetIsError
  };
};
